module.exports = __webpack_public_path__ + "img/peigen.b23f1d4b.png";